import { cn } from "@/lib/utils";

interface TutorialProgressDotsProps {
  total: number;
  current: number;
  onDotClick: (index: number) => void;
}

export const TutorialProgressDots = ({ total, current, onDotClick }: TutorialProgressDotsProps) => {
  return (
    <div className="flex items-center justify-center gap-2">
      {Array.from({ length: total }).map((_, index) => (
        <button
          key={index}
          onClick={() => onDotClick(index)}
          className={cn(
            "w-2.5 h-2.5 rounded-full transition-all duration-300",
            index === current
              ? "bg-accent w-6"
              : "bg-white/30 hover:bg-white/50"
          )}
          aria-label={`Aller au slide ${index + 1}`}
        />
      ))}
    </div>
  );
};
